<template>
  <article class="">
     <cabecera></cabecera>
    <!-- <section class="portada">
      <div class="linea">

        <h1>Relaciones Institucionales</h1>
      </div>
    </section> -->
    <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Proveedores</h2>
    </section>
   <!--  <section class="lineas">
      <div class="linea1"></div>
      <div class="linea2"></div>
      <div class="linea3"></div>
    </section> -->
    <section class="descripcion">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-12 col-md-6">
            <p class="text-center">En caso de dudas de navegación del portal Ariba, por favor, acceda a nuestro <strong>Centro de Ayuda</strong> ubicado en la esquina superior derecha de su cuenta.</p> 
            <div class="bnt">
              <a target="_blank" href="https://service.ariba.com/Supplier.aw/125042059/aw?awh=r&awssk=Y4TW9pUw&dard=1&ancdc=1">Acceso<br> ARIBA Network</a>
              <a target="_blank" href="static/pdf/MEGA - Manual Ariba Proveedores.pdf">manual<br> de proveedores</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <pie></pie>
  </article>
</template>

<script>
import Cabecera from '@/components/Cabecera'
import Pie from '@/components/Pie'
export default {
  name: 'proveedores',
  components: {
    Cabecera,
    Pie
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 50%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
.descripcion
  padding-top: 50px
  .bnt
    display: flex
    align-items: center
    width: 100%
    justify-content: space-between
    padding: 30px 0 100px
    @media (max-width: 550px)
      flex-direction: column
      justify-content: center
      align-items: center
    a
      padding: 20px 40px
      background: #004d9e
      font-weight: 600
      font-size: 18px
      line-height: 26px
      text-decoration: none
      text-align: center
      color: #fff
      text-transform: uppercase
      border: 1px solid #004d9e
      transition: all .45s ease-in-out
      letter-spacing: 2px
      @media (max-width: 550px)
        padding: 20px
        margin: 10px 0
      &:hover
        color: #004d9e
        background: #fff
</style>



// WEBPACK FOOTER //
// src/components/proveedores/proveedores.vue